<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="representativeTransferRequests.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="120"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="representativeTransferRequest"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :representative-transfer-request="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="representativeTransferRequests.meta && representativeTransferRequests.meta.per_page"
        layout="total, prev, pager, next"
        :total="representativeTransferRequests.meta && representativeTransferRequests.meta.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'created_at',
          order: 'descending',
        },
      };
    },
    computed: {
      representativeTransferRequests() {
        return this.$store.getters['representativeTransferRequest/representativeTransferRequests']
      },

      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['representativeTransferRequest/tableConfig']));
      },
      loading() {
        return this.$store.getters['representativeTransferRequest/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('representativeTransferRequest/setFilterString', '');
      this.$store.commit('representativeTransferRequest/setCurrentPage', this.currentPage);
      this.$store.commit('representativeTransferRequest/setSorting', this.currentSort);
      await this.$store.dispatch('representativeTransferRequest/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('representativeTransferRequest/setCurrentPage', val);
        this.$store.dispatch('representativeTransferRequest/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('representativeTransferRequest/setSorting', { prop, order});
          this.$store.dispatch('representativeTransferRequest/fetchAll');
        }
      },
    },
  };
</script>
